// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0ee9eb46","505":"aa240f5f"}[chunkId] + ".chunk.js";
};